import $ from 'jquery';
import 'slick-carousel';
import './style.scss';

$(document).ready(function() {
    // Iterate over each carousel block on the page
    $('.uscarch-carousel').each(function() {
        const $carousel = $(this);

        // Add accessibility attributes for screen readers
        $carousel.attr('role', 'region');
        $carousel.attr('aria-live', 'polite');

        // Retrieve settings from the data attributes
        const slideWidthType = $carousel.parent().data('slide-width-type');
        const fixedSlideWidth = parseInt($carousel.parent().data('fixed-slide-width')) || null;
        const fixedSlideWidthTablet = parseInt($carousel.parent().data('fixed-slide-width-tablet')) || fixedSlideWidth;
        const fixedSlideWidthMobile = parseInt($carousel.parent().data('fixed-slide-width-mobile')) || fixedSlideWidthTablet;
        const randomOrder = $carousel.parent().data('random-order');
        const infinite = $carousel.parent().data('infinite'); // Retrieve the infinite setting

        // Function to shuffle the slides if "Random Order" is enabled
        function shuffle($elements) {
            const allElements = $elements.get();
            const shuffled = allElements.sort(() => 0.5 - Math.random());
            $elements.each(function(index) {
                $(this).parent().append(shuffled[index]);
            });
        }

        if (randomOrder) {
            shuffle($carousel.find('.wp-block-column'));
        }

        // Function to update slide widths based on the current screen size
        function updateSlideWidths() {
            $carousel.find('.wp-block-column').each(function() {
                const $column = $(this);
                let width = fixedSlideWidth + 'px';

                // Adjust width for tablet and mobile views
                if ($(window).width() <= 1024 && fixedSlideWidthTablet) {
                    width = fixedSlideWidthTablet + 'px';
                }
                if ($(window).width() <= 600 && fixedSlideWidthMobile) {
                    width = fixedSlideWidthMobile + 'px';
                }

                $column.css('width', width);
            });

            $carousel.slick('setPosition');  // Refresh the Slick carousel instance
        }

        // Initialize the Slick carousel based on slide width type
        if (slideWidthType === 'fixed' && fixedSlideWidth) {
            $carousel.slick({
                variableWidth: true,
                arrows: true,
                dots: false,
                infinite: infinite,  // Use the infinite setting
                autoplay: false,
                adaptiveHeight: false,
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',  // Lazy load images
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide">Previous</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide">Next</button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });

            updateSlideWidths();

            // Debounced resize event to reduce the number of resize event calls
            let resizeTimer;
            $(window).on('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    updateSlideWidths();
                }, 250);  // Adjust the delay as needed (250ms is a typical debounce value)
            });
        } else {
            // Default initialization for scale to fit
            $carousel.slick({
                slidesToShow: parseInt($carousel.parent().data('slides-to-show')) || 1,
                slidesToScroll: parseInt($carousel.parent().data('slides-to-show')) || 1,
                arrows: true,
                dots: false,
                infinite: infinite,  // Use the infinite setting
                autoplay: false,
                adaptiveHeight: true,
                centerMode: false,
                lazyLoad: 'ondemand',  // Lazy load images
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide">Previous</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide">Next</button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: parseInt($carousel.parent().data('slides-to-show-tablet')) || 1,
                            slidesToScroll: parseInt($carousel.parent().data('slides-to-show-tablet')) || 1,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: parseInt($carousel.parent().data('slides-to-show-mobile')) || 1,
                            slidesToScroll: parseInt($carousel.parent().data('slides-to-show-mobile')) || 1,
                        }
                    }
                ]
            });
        }
    });
});
